import { defineMessages } from 'react-intl-next';

export default defineMessages({
	header: {
		id: 'navigation.error.fallback.ui.header.non-final',
		defaultMessage: 'We couldn’t fetch your items',
		description: 'Header when an unknown error occurs',
	},
	description: {
		id: 'navigation.error.fallback.ui.header.description.non-final',
		defaultMessage: 'Refresh the page and try again.',
		description: 'Description when an unknown error occurs',
	},
	// TODO: Improve this, they should be defined in a errorFallbackUI specific to customization modal
	customizationHeader: {
		id: 'navigation.customisation.modal.error.fallback.ui.header.non-final',
		defaultMessage: 'We couldn’t load your customization options',
		description: 'Header when an unknown error occurs',
	},
	customizationDescription: {
		id: 'navigation.customisation.modal.error.fallback.ui.header.description.non-final',
		defaultMessage: 'Refresh the page and try again.',
		description: 'Description when an unknown error occurs',
	},
});
